export default __webpack_public_path__ + "static/media/img_papaground07.f23e2b57.jpg";